import { useEffect, useState, createContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import axios from "axios";

import "./App.css";

import Classes from "./components/classes";
import Performances from "./components/performances";
import Tags from "./components/tags";
import Lessons from "./components/lessons";
import Workshops from "./components/workshops";
import Page from "./components/page";
import Nav from "./components/nav";
import KidsClasses from "./components/kidsClasses";

export const api = createContext();

function App() {
  const [apiData, setApiData] = useState([]);

  useEffect(() => {
    async function getData() {
      const { data } = await axios.get(
        "https://www.viewcy.com/api/o/jalopytheatre/courses"
      );
      setApiData(data.data);
    }
    getData();
  }, []);

  return (
    <api.Provider value={{ apiData, setApiData }}>
      <Router>
        <Nav />
        <div className="container">
          <Switch>
            <Route path="/classes" component={Classes} />
            <Route path="/kids-classes" component={KidsClasses} />
            <Route path="/performances" component={Performances} />
            <Route path="/workshops" component={Workshops} />
            <Route path="/lessons" component={Lessons} />
            <Route path="/tags/:tag_id" component={Tags} />
            <Route exact path="/" component={Page} />
            <Redirect to="/" component={Page} />
          </Switch>
        </div>
      </Router>
    </api.Provider>
  );
}

export default App;
